import { useEffect, useState } from "react";
import { getConsent, setConsent, initMarketingConsent } from "@/lib/consent";

/* Consent-aware banner. Only appears when marketing/retargeting is actually
   enabled AND consent is required AND the visitor hasn't decided yet. With
   retargeting disabled by default, this renders nothing (zero CWV impact). */
export const ConsentBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let alive = true;
    initMarketingConsent().then((cfg) => {
      if (!alive) return;
      const needed = cfg?.retargeting_enabled && cfg?.consent_required && !getConsent();
      setShow(!!needed);
    });
    return () => { alive = false; };
  }, []);

  if (!show) return null;
  const decide = (v) => { setConsent(v); setShow(false); };

  return (
    <div data-testid="consent-banner" className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 rounded-2xl border border-[#232323] bg-[#0b0b0b]/95 backdrop-blur p-5 shadow-2xl">
      <p className="text-sm text-zinc-300 leading-relaxed">
        We use privacy-respecting analytics. Allow marketing cookies to help us measure campaigns?
        Essential, first-party analytics runs either way.
      </p>
      <div className="mt-4 flex gap-2">
        <button data-testid="consent-accept" onClick={() => decide("granted")} className="flex-1 rounded-lg bg-cyan-500 px-4 py-2 text-sm font-semibold text-black hover:bg-cyan-400 transition-colors">Allow</button>
        <button data-testid="consent-decline" onClick={() => decide("denied")} className="flex-1 rounded-lg border border-[#2a2a2a] px-4 py-2 text-sm text-zinc-300 hover:border-[#3a3a3a] transition-colors">Decline</button>
      </div>
    </div>
  );
};
